<template>
  <el-row>
    <el-col :span="24">
      <el-table :data="nodeUserList">
        <el-table-column label="模板名称" align="center" prop="templateName" width="80"/>
        <el-table-column label="节点名称" align="center" prop="nodeName"/>
        <el-table-column label="内容文本" align="center" prop="nodeText" :show-overflow-tooltip='true' width="200">
          <template slot-scope="scope">
            <span style="color: #00afff" onclick="">查看所有</span><br/><span>{{scope.row.nodeText}}</span>
          </template>
        </el-table-column>
        <el-table-column label="天数" align="center" prop="daySeq"/>
        <el-table-column label="期望时间" align="center" prop="pushDate"/>
        <el-table-column label="企微消息" align="center" prop="msgQiyeDate">
          <template slot-scope="scope">
            <span style="color: #999093" v-if="!scope.row.msgQiyeStatus && !scope.row.msgQiyeResult">未开启</span>
            <span style="color: #157a0c" v-if="scope.row.msgQiyeStatus && !scope.row.msgQiyeResult">等待执行</span>
            <span style="color: #C03639" v-else>{{ scope.row.msgQiyeResultName }} >> {{ scope.row.msgQiyeEmployeeUserId}}</span>
            <br/>
            <span>{{scope.row.msgQiyeDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="小程序消息" align="center" prop="msgTemplateDate">
          <template slot-scope="scope">
            <span style="color: #999093" v-if="!scope.row.msgTemplateStatus && !scope.row.msgTemplateResult">未开启</span>
            <span style="color: #157a0c" v-if="scope.row.msgTemplateStatus && !scope.row.msgTemplateResult">等待执行</span>
            <span style="color: #C03639" v-else>{{ scope.row.msgTemplateResultName }}</span>
            <br/>
            <span>{{scope.row.msgTemplateDate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="短信消息" align="center" prop="msgCodeDate">
          <template slot-scope="scope">
            <span style="color: #999093" v-if="!scope.row.msgCodeStatus && !scope.row.msgCodeResult">未开启</span>
            <span style="color: #157a0c" v-if="scope.row.msgCodeStatus && !scope.row.msgCodeResult">等待执行</span>
            <span style="color: #C03639" v-else>{{ scope.row.msgCodeResultName }}</span>
            <br/>
            <span>{{scope.row.msgCodeDate}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
  </el-row>
</template>

<script>

import {listStandardTemplateNodeUser} from "@/api/biz/StandardTemplateNodeUser";

export default {
  props: {
    user: {
      type: Object
    }
  },
  data() {
    return {
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      // 总条数
      total: 0,
      // 用户体重记录表格数据
      nodeUserList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询用户体重记录列表 */
    getList() {
      this.queryParams.userId = this.user.id;
      this.loading = true;
      listStandardTemplateNodeUser(this.queryParams).then(response => {
        this.nodeUserList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    close() {
      this.$tab.closePage();
    }
  }
};
</script>
